import {
  type RouteRecordRaw,
} from 'vue-router'

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/dashboard',
    name: 'home',
    component: () => import('@clevver/components/file-preview-grid.vue'),
  },
  {
    path: '/dashboard/archive',
    name: 'archive',
    component: () => import('@clevver/views/archive-view.vue'),
  },
  {
    path: '/dashboard/file/:id',
    name: 'file-details',
    component: () => import('@clevver/components/file-details.vue'),
  },
  {
    path: '/dashboard/upload',
    component: () => import("@clevver/components/upload-view.vue"),
  },
  {
    path: '/dashboard/account',
    component: () => import("@clevver/views/account-view.vue"),
    children: [
      {
        path: '',
        redirect: '/dashboard/account/billing',
      },
      {
        path: 'billing',
        name: 'billing',
        component: () => import("@clevver/views/account/billing-view.vue"),
      },
      {
        path: 'password',
        name: 'password',
        component: () => import("@clevver/views/account/password-view.vue"),
      },
      {
        path: 'security-keys',
        name: 'security-keys',
        component: () => import("@clevver/views/account/security-keys-view.vue"),
      },
      {
        path: 'api-keys',
        name: 'api-keys',
        component: () => import("@clevver/views/account/api-keys-view.vue"),
      },
    ],
  },
  {
    path: '/dashboard/billing',
    redirect: '/dashboard/account/billing',
  },
]
